import { gql } from '@apollo/client';

export const SIGNIN = gql`
  mutation LoginMutation($loginInput: LoginInput!) {
    login(loginInput: $loginInput)
  }
`;
